import { useMemo } from 'react';
import { constants } from '@yola/subscription-manager-js';
import featureConfigurator from '../helpers/feature-configurator';
import ecommerceFeatureConfiguration from '../helpers/ecommerce-feature-configuration';
import sortByFeatureId from '../helpers/sort-by-feature-id';
import getFeatureAvailability from '../helpers/get-feature-availability';
import updateHighlightedFeaturesPosition from '../helpers/update-highlighted-features-position';
import getNotAvailableFeatures from '../helpers/get-not-available-features';

const { hostingPackageFeatureNames } = constants;

const defaultHighlightedFeatures = [
  { name: hostingPackageFeatureNames.FREE_DOMAIN_PROMO, highlightDisabledOnly: true },
];

const usePlanFeatures = ({
  paymentPeriod,
  disabledPlans,
  availablePlansData,
  areEcommercePlans,
  featureFlags,
  isB2C,
  highlightedFeatures,
  domainDiscount,
}) =>
  useMemo(() => {
    const { features, plans } = availablePlansData;
    const activePlans = plans.filter((plan) => !disabledPlans.includes(plan.id));
    const featureConfigs = areEcommercePlans ? ecommerceFeatureConfiguration : featureConfigurator;
    const notAvailableFeatures = getNotAvailableFeatures(domainDiscount);
    const featuresToHighlight = highlightedFeatures || defaultHighlightedFeatures;

    const availableFeatures = features.reduce((featureList, feature) => {
      if (
        featureConfigs[feature] &&
        getFeatureAvailability(feature, featureFlags, notAvailableFeatures)
      ) {
        const highlightedFeature = featuresToHighlight.find(({ name }) => name === feature);
        const featureConfig = featureConfigs[feature].config(activePlans, {
          paymentPeriod,
          isB2C,
          highlightDisabledOnly: highlightedFeature?.highlightDisabledOnly,
        });
        featureList.push({
          ...featureConfig,
          highlighted:
            featureConfig.highlighted ||
            Boolean(highlightedFeature && !highlightedFeature.highlightDisabledOnly),
        });
      }

      return featureList;
    }, []);

    return updateHighlightedFeaturesPosition(
      sortByFeatureId(availableFeatures, areEcommercePlans),
      featuresToHighlight
    );
  }, [
    paymentPeriod,
    disabledPlans,
    availablePlansData,
    areEcommercePlans,
    featureFlags,
    isB2C,
    highlightedFeatures,
    domainDiscount,
  ]);

export default usePlanFeatures;
